import regex from "@/utils/data/regex";
import dateFormatService from '@/service/date-format-service';

export default {
    required(value, errorMsg = "Angabe erforderlich") {
        return value !== undefined && value !== "" && value !== null || errorMsg;
    },
    hausnummer(value, errorMsg = "Keine gültige Hausnummer.") {
        if (isNaN(value) === true) {
            return "Keine gültige Hausnummer. Eine Hausnummer darf nur Zahlen enthalten."
        }

        if (value > 10000) {
            return "Keine gültige Hausnummer. Die größtmöglichste Hausnummer lautet \"10000\"";
        }

        const hausnummerRegex = new RegExp("^[1-9]{1}[0-9]{0,4}$");
        return undefinedOrEmpty(value) ? true : hausnummerRegex.test(value) || errorMsg;
    },
    plzDeutschland(value) {
        const plzRegex = new RegExp("^[0-9]{5}$");
        return undefinedOrEmpty(value) ? true : plzRegex.test(value) || "Keine gültige Postleitzahl";
    },
    plzAusland(value) {
        const plzRegex = new RegExp("^([0-9]|[A-Z]|\\s|-){1,12}$");
        return undefinedOrEmpty(value) ? true : plzRegex.test(value) || "Keine gültige Postleitzahl";
    },
    emailValidation(value) {
        const emailRegex = new RegExp("^(([^<>()\\[\\]\\\\.,;:\\s@\"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@\"]+)*)|(\".+\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$");
        return undefinedOrEmpty(value) ? true : emailRegex.test(value) || "E-Mail muss ein gültiges Format haben"
    },
    passwordValidation(value) {
        // Passwortrichtlinien: Das Passwort muss mindestens 8 Zeichen lang sein und mind. vier Zeichenarten (Kleinbuchstaben, Großbuchstaben, Zahlen, Sonderzeichen) enthalten.
        let password = String(value);
        let message = "Das Passwort muss die Passwortrichtlinien erfüllen. Das Passwort muss mindestens 8 Zeichen lang sein und mind. vier Zeichenarten (Kleinbuchstaben, Großbuchstaben, Zahlen, Sonderzeichen) enthalten";
        let hasNumerics = /\d+/.test(password);
        let hasCapitals = /[A-Z]+/.test(password);
        let hasSmalls = /[a-z]+/.test(password);
        let hasSepcials = /[!@#$%&\\/=\\?_\\.,:;\\-]+/.test(password);
        return (hasNumerics && hasCapitals && hasSmalls && hasSepcials && password.length >= 8) || message;
    },
    passwordValidationMultipleFactorAuthentication(value) {
        // Passwortrichtlinien: Das Passwort muss mindestens 8 Zeichen lang sein und mind. drei Zeichenarten (Kleinbuchstaben, Großbuchstaben, Zahlen, Sonderzeichen) enthalten.
        const passwordRegex = new RegExp("^((?=.*?[A-Z])(?=.*?[a-z])(?=.*?\\d)|(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[^a-zA-Z0-9])|(?=.*?[A-Z])(?=.*?\\d)(?=.*?[^a-zA-Z0-9])|(?=.*?[a-z])(?=.*?\\d)(?=.*?[^a-zA-Z0-9])).{8,}$");
        return undefinedOrEmpty(value) ? true : passwordRegex.test(value) || "Das Passwort muss die Passwortrichtlinien erfüllen. Das Passwort muss mindestens 8 Zeichen lang sein und mind. drei Zeichenarten (Kleinbuchstaben, Großbuchstaben, Zahlen, Sonderzeichen) enthalten"
    },
    wiederholungValidation(string, value1, value2) {
        return value1 === value2 || `${string} stimmen nicht überein`
    },
    wiederholungValidationCaseInsensitive(string, value1, value2) {
        value1 ? value1 = value1.toLowerCase() : '';
        value2 ? value2 = value2.toLowerCase() : '';
        return value1 === value2 || `${string} stimmen nicht überein`
    },
    checked(value, errorMsg = 'Muss angehakt sein') {
        return (value !== undefined && value === true) || errorMsg;
    },
    positiveNumberValidation(value) {
        const posNumberRegex = new RegExp("^[0-9]*$");
        return undefinedOrEmpty(value) ? true : posNumberRegex.test(value) || "Nur positive, ganze Zahlen erlaubt";
    },
    nichtFrueherAlsValidator(date1, date2) {
        if (date1 == null || date2 == null) {
            return true;
        }
        const earlierDate = new Date(date1);
        const laterDate = new Date(date2);
        return undefinedOrEmpty(earlierDate) && undefinedOrEmpty(laterDate)
            ? true
            : earlierDate < laterDate || 'Das Datum darf nicht früher sein.';
    },
    nichtSpaeterAlsValidator(date1, date2) {
        if (date1 == null || date2 == null) {
            return true;
        }
        const earlierDate = new Date(date1);
        const laterDate = new Date(date2);
        return undefinedOrEmpty(earlierDate) && undefinedOrEmpty(laterDate)
            ? true
            : earlierDate < laterDate || 'Das Datum darf nicht später sein.';
    },
    requiredIf(statement, value, errorMsg = undefined) {
        return statement ? this.required(value, errorMsg) : true;
    },
    ganzeZahlMitNull(value) {
        const numberRegex = new RegExp("^(0)$|^[1-9][0-9]*$")
        return undefinedOrEmpty(value) ? true : numberRegex.test(value);
    },
    ganzeZahlOhneNull(value) {
        const numberRegex = new RegExp("^[1-9][0-9]*$")
        return undefinedOrEmpty(value) ? true : numberRegex.test(value);
    },
    ganzeZahlOderZahlMitMinEinerZahlNachKommaMitNull(value) {
        return undefinedOrEmpty(value) ? true : (new RegExp(regex.REGEX_ZAHL_MIT_KOMMA_NULL_ERLAUBT)).test(value) || 'Keine gültige Zahl';
    },
    ganzeZahlOderzahlMitMinEinerZahlNachKommaOhneNull(value) {
        const zahlMitMinEinerZahlNachKomma = new RegExp("^(0{1,1},[0-9]{1,2})$|^([1-9][0-9]*(?:,[0-9]{1,2}){0,1})$");
        return undefinedOrEmpty(value) ? true : zahlMitMinEinerZahlNachKomma.test(value) || 'Keine gültige Zahl';
    },
    mindestensAnzahl(value, anzahl, anzahlWort) {
        return undefinedOrEmpty(value) ? true : value.length >= anzahl || `Es müssen mindestens ${anzahlWort} erfasst werden`;
    },
    kleinerEinJahr(date1, date2) {
        if (date1 == null || date2 == null) {
            return true;
        }
        const earlierDate = new Date(date1);
        const laterDate = new Date(date2);

        const earlierDateOneYearFromNow = earlierDate;
        earlierDateOneYearFromNow.setFullYear(earlierDate.getFullYear() + 1);
        earlierDateOneYearFromNow.setDate(earlierDateOneYearFromNow.getDate() - 1);

        return undefinedOrEmpty(earlierDate) && undefinedOrEmpty(laterDate)
            ? true
            : earlierDateOneYearFromNow.getTime() > laterDate.getTime() || 'Ein Rumpfwirtschaftsjahr muss die Länge eines regulären Jahres unterschreiten.';
    },
    genauEinJahr(date1, date2) {
        if (date1 == null || date2 == null) {
            return true;
        }
        const earlierDate = new Date(date1);
        const laterDate = new Date(date2);

        const earlierDateOneYearFromNow = earlierDate;
        earlierDateOneYearFromNow.setFullYear(earlierDate.getFullYear() + 1);
        earlierDateOneYearFromNow.setDate(earlierDateOneYearFromNow.getDate() - 1);

        let result = dateFormatService.formatDate(earlierDateOneYearFromNow) === dateFormatService.formatDate(laterDate);

        return undefinedOrEmpty(earlierDate) && undefinedOrEmpty(laterDate)
            ? true
            : result || 'Die Länge eines Wirtschaftsjahres muss genau ein Jahr betragen.';
    },
}

const undefinedOrEmpty = function (value) {
    return value === undefined || value === "" || value === null;
}
